export { TableFormReduxContainer as TableForm } from './TableForm.container';
